import PrimaryButton from '../shared/buttons/PrimaryButton';
import Input from '../shared/formInput/Input';
import FormGroup from '../shared/containers/FormGroup';
import { Form, Formik } from 'formik';
import { Box, Typography } from '@mui/material';
import * as Yup from "yup";
import FileInput from '../shared/formInput/FileInput';
import TextEditorInput from '../shared/formInput/TextEditorInput';
import SwitchInput from '../shared/formInput/SwitchInput';
import CheckBoxInput from '../shared/formInput/CheckBoxInput';
import SelectInput from '../shared/formInput/SelectInput';
import { useEffect, useState } from 'react';
import axios from '../../utils/axios';
import useAuth from "../../hooks/useAuth";
import { Button } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {useNotifications} from 'reapop';
import { useNavigate } from 'react-router-dom';


const AriticleForm = ({initialValues, onSubmit, submitButtonChildren}) => {
    const {auth} = useAuth();
	const [groupOptions, setGroupOptions] = useState(null)
    const fileTypes = ["JPG","JPEG", "PNG"];
    const {notify} = useNotifications();
    const navigate = useNavigate();

    const showGroup = (values) => {
        return values.includes('group')
    }

    const isSlider = (values) => {
        return values.includes('slider')
    }

    const displaySticker = (values) => {
        return values.includes('group') || values.includes('single')
    }

    const getArticleCategory = async () => {
        try {
            let config = {
                headers: {
                  'Authorization': `Bearer ${auth?.accessToken}`
                }
              }
            const response = await axios.get('article/category', config);
            const options = response?.data?.map(option => ({label: option.name, value: option.id}));
            setGroupOptions(options);
        } catch (error) {
            setGroupOptions([])
            // console.error(error);
        }
    }    

    const deleteButtonAction = async () => {
        await axios.delete(`/article/${initialValues.id}`); 
        navigate('/article');
        notify('L\'article a été supprimé', 'info', {dismissAfter: 5000}); 
    }    
    
    const deleteArticle = () => { 
        const buttons = [
            {
                name: "Supprimer",
                primary: true,
                onClick: async() => {
                    await deleteButtonAction();
                }
            },
            {
                name: "Annuler",
                primary: false,
                onClick: () => {
                    return;
                  }
            }
        ]
        notify('L\'article sera supprimé définitvement. Continuer ?', 'info', {buttons: buttons});
    };
    
    useEffect(() => {
        getArticleCategory();
    }, []);

    const validationSchema = Yup.object({
        title: Yup.string()
            .required("champ requis"),
        description: Yup.string()
            .required("champ requis"),
        content: Yup.string()
            .required("champ requis"),        
        display: Yup.array()
            .min(1, "champ requis"),
        group: Yup.string().when('display', {
            is: showGroup, 
            then: Yup.string().required('champ requis'),
            otherwise: Yup.string(),
        }),
        image: Yup.array().nullable().when('display', {
            is: displaySticker, 
            then: Yup.array().min(1, "champ requis")
        }),
        image_slider: Yup.array().nullable().when('display', {
            is: isSlider, 
            then: Yup.array().min(1, "champ requis")
        })
    });

    const formStyle = {
        margin: "0 auto"
    };

	return (
		<>
			<Formik {...{ initialValues, onSubmit, validationSchema, enableReinitialize:true}}>
            {({errors, isValid, dirty, values, touched, setFieldValue, ...rest}) => {
                
                // if the field 'display' those not have (value => group) then reset 'group' field
                if(!values?.display?.includes('group') && dirty) {
                    values.group = ''
                    touched.group = false
                    if (!values?.display?.includes('single')) {
                        values.image = ''
                        touched.image = false 
                    }
                }

                if(!values?.display?.includes('slider') && dirty) {
                    values.image_slider = ''
                    touched.image_slider = false
                }

                return (
                    <Box>
                        {errors.createError && <p>{errors.createError}</p>}
                        <Form autoComplete="off" style={formStyle}>
                            <FormGroup>
                                <Input
                                    {...{
                                        name: "title",
                                        label: "Titre"                                        
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    multiline
                                    {...{
                                        name: "description",
                                        label: "Description",
                                    }}
                                    inputProps={{ maxLength: 150 }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    multiline
                                    {...{
                                        name: "tags",
                                        label: "Tags",
                                        required: false,
                                        helperText: 'Exemple: Formation, Filière,...'
                                    }}
                                    inputProps={{ maxLength: 150 }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <CheckBoxInput
                                    {...{
                                        name: "display",
                                        label: "Slider",
                                        value: "slider",
                                    }}
                                />
                                <CheckBoxInput
                                    {...{
                                        name: "display",
                                        label: "Groupe",
                                        value: "group",
                                    }}
                                />
                                <CheckBoxInput
                                    {...{
                                        name: "display",
                                        label: "Article seul",
                                        value: "single",
                                    }}
                                />
                            </FormGroup>
                            <FormGroup>
                                {groupOptions && values?.display?.includes('group') && 
                                    <SelectInput
                                        {...{
                                            name: "group",
                                            options: groupOptions,
                                            label: "Groupe de publication",
                                        }}
                                    />
                                }
                            </FormGroup>
                            {(values?.display?.includes('single') || 
                            values?.display?.includes('group')) && 
                                (<FormGroup>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Image pour vignette (format 4:3)
                                    </Typography>
                                    <FileInput
                                        base64
                                        {...{
                                            name: "image",
                                            fileTypes,
                                            label: "Télécharger ou déposer votre image ici",
                                        }}
                                    />
                                </FormGroup>)
                            }
                            {values?.display?.includes('slider') &&
                                (
                                <FormGroup>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Image pour slider (format 2:1)
                                    </Typography>
                                    <FileInput
                                        base64
                                        {...{
                                            name: "image_slider",
                                            fileTypes,
                                            label: "Télécharger ou déposer votre image ici",
                                        }}
                                    />
                                </FormGroup>)
                            }                            
                            <FormGroup>
                                <TextEditorInput
                                    {...{
                                        name: "content",
                                        label: "Contenu de l'article",
                                    }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <SwitchInput
                                    {...{
                                        name: "is_active",
                                        label: "Publier l'article",
                                    }}
                                />
                            </FormGroup>
                            
                            <PrimaryButton type="submit" disabled={!isValid || !dirty}>
                                {submitButtonChildren}
                            </PrimaryButton>
                            <Button 
                                color="error" 
                                variant="contained"
                                startIcon={<DeleteOutlineIcon/>}
                                onClick={deleteArticle}
                                sx={{
                                  float: 'right'  
                                }}
                            >
                                Supprimer
                            </Button>
                        </Form>
                    </Box>
                )
            }}
        	</Formik>
		</>
	);
};

export default AriticleForm;